import React from 'react'

export const Svg  = (props) => {
  return (
    <>
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={640.006}
    height={480}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16933.48 12700.05"
    {...props}
  >
    <defs>
      <style>
        {".fil2{fill:#0f62ac}.fil1{fill:#fefefe;fill-rule:nonzero}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_3144285496368">
        <path
          d="M775.48 7497.21 0 594.57 7083.62 25.78l-1085.85 8324.5z"
          style={{
            fill: "#ee3147",
          }}
        />
        <path
          d="M1522.05 7619.15V1144H5548.4v774.65H2371.77v2000.08H5548.4v754.61H2371.77v3084.63z"
          className="fil1"
        />
        <path
          d="m7368 8919 568.69-7962.54L14865.14 0l2068.34 8065.93z"
          className="fil2"
        />
        <path
          d="M7973.19 2116.12h960.24l984.54 2883.82c66.57 194.59 132.13 360.77 181.34 505.1 48.79 143.83 88.86 280.13 125.87 406.61l1910.54-3966.4 1941.9 3915.71c36.51-118.45 90.83-246.08 140.23-390.55L15389.13 2043l370.43 1445-1585.52 4622.32L12073.65 3907l-2050.88 4222.91-2049.58-6013.79z"
          className="fil1"
        />
        <path
          d="M451.9 12606.16v-2410.43h1532.88v332.65H898.25v600.91h1086.53v343.82H898.25v1133.05H451.9zm2458.78-946.96h765.11l-281.18-549.71c-15.98-35.28-33.19-75.78-50.47-121.33-17.35-45.47-35.28-96.01-52.6-152.28-15.52 52.77-30.6 102.31-48.03 147.78-16.63 45.51-33.84 87.09-51.26 125.83l-281.57 549.71zM4145 12606.16l-311.74-620.96H2746.15l-318.98 620.96h-469.24l1329.83-2505.87 1327.93 2505.87H4145zm572.36-482.79 356.06-144.44c33.94 107.43 95.94 189.45 185.58 245.61 90.44 56.77 205.57 84.93 345.19 84.93 132.49 0 238.19-32.66 316.31-97.17 78.05-64.73 117.19-151.32 117.19-259.68 0-141.6-133.93-268.11-401.67-378.89-37.66-16.16-65.74-28.58-86.26-35.96-302.2-129.79-503.99-246.65-604.37-351.7-100.62-104.48-151.13-233.15-151.13-384.47 0-196.75 76.21-355.73 227.85-477.71 151.68-121.93 350.88-182.63 597.45-182.63 202.26 0 371.9 34.23 508.46 102.75 136.3 68.65 230.34 167.62 282.9 295.68l-348.86 157.94c-55.12-75.89-115.42-130.94-181.23-165.83-65.38-35.24-140.95-52.7-226.13-52.7-119.78 0-214.97 27.47-285.53 81.97-71.1 55.12-106.31 128.78-106.31 220.8 0 145.02 154.95 279.95 465.43 404.74 23.72 10.11 42.41 17.96 55.8 22.97 271.42 110.09 457.76 217.45 559.68 322.03 101.1 105.2 151.57 236.1 151.57 392.78 0 228.29-81.9 409.81-245.85 544.13-163.92 134.36-384.79 201.72-663.81 201.72-233.79 0-425.1-47.16-575.05-141.59-149.16-94.33-247.08-229.3-293.27-405.28zm3153.5-1594.99v2077.78h-446.49v-2077.78h-729.83v-332.65H8596.8v332.65h-725.94zm740.74-332.65h441.1l519.21 1216.82c33.85 80.32 62.14 150.6 85.87 210.76 23.04 60.05 42.8 116.79 60.7 169.64 43.6-127.59 89.14-251.69 137.02-373.7 5.87-15.81 10.44-25.85 12.82-31.5l551.29-1287.46 582.15 1312.26c27.51 63.51 53.14 127.52 77.37 190.96 24.37 63.61 47.41 127.59 68.58 192.82 12.6-49.5 29.38-103.97 50.51-162.94 21.03-59.66 48.57-129.82 82.52-210.76l516.12-1226.9h444.48l-1063.67 2504.32-626.15-1374.59c-27.61-61.88-52.96-120.89-75.56-177.12-22.4-56.74-42.24-110.1-59.41-160.68-22 64.59-42.95 125.29-63.97 182.06-21.17 56.24-42.95 110.71-66.1 161.83l-614.77 1368.5-1060.11-2504.32zm4446.02 1463.47h765.04l-281.1-549.71c-15.95-35.28-33.31-75.78-50.44-121.33-17.25-45.47-35.28-96.01-52.53-152.28-15.44 52.77-30.71 102.31-48.13 147.78-16.53 45.51-33.81 87.09-51.16 125.83l-281.68 549.71zm1234.39 946.96-311.74-620.96h-1087.14l-318.87 620.96h-469.28l1329.65-2505.87 1328 2505.87h-470.62zm1110.91 0v-1103.21l-924.67-1307.22h468.6l575.81 818.36c13.9 20.73 31.22 48.24 51.85 82.48 20.34 33.84 41.4 70.34 62.6 110.23 17.5-38.88 35.79-74.74 55.19-109.05 19.84-33.77 39.75-65.27 61.35-93.78l590.93-808.24h446.14l-945.62 1307.22v1103.21h-442.18z"
          className="fil2"
        />
      </g>
    </g>
  </svg>
    </>
  )
}
